import Black from './khan.black.svg';
import Gray from './khan.gray.svg';
import Orange from './khan.orange.svg';

export { Black, Gray, Orange };
